"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangopayUserStatus = void 0;
var MangopayUserStatus;
(function (MangopayUserStatus) {
    MangopayUserStatus["Pending"] = "PENDING_USER_ACTION";
    MangopayUserStatus["Active"] = "ACTIVE";
})(MangopayUserStatus || (exports.MangopayUserStatus = MangopayUserStatus = {}));
//# sourceMappingURL=MangopayUserStatus.js.map